const alertClassName = 'AlertBanner';
const alertClass = `.${alertClassName}`;
import throttle from 'lodash/throttle';
const selectors = {
	alertBanner: '.AlertBanner',
	interstitialOfferBanner: '.InterstitialOfferBanner',
	closeBanner: '.Banner-closeButton',
};

/**
 * Displays an alert if there's one on the page and it hasn't been
 * dismissed by the user
 * @return {undefined}
 */
export default function alertBanner() {
	const alertBannerFeed = $('body').attr('data-alert-banner');
	const interstitialOfferBanner = document.querySelector(selectors.interstitialOfferBanner);
	const setAlertHeightProperty = () => {
		const banner = document.querySelector(selectors.alertBanner);
		let bannerHeight = banner ? Math.floor(banner.offsetHeight) : 0;
		bannerHeight += interstitialOfferBanner
			? Math.floor(interstitialOfferBanner.clientHeight)
			: 0;
		document.documentElement.style.setProperty('--alertheight', `${bannerHeight}px`);
	};

	window.addEventListener('resize', throttle(setAlertHeightProperty, 50));

	if (alertBannerFeed) {
		$.get(alertBannerFeed, {}, (data, status) => {
			if (status === 'success' && data) {
				const skipToMain = $('.SkipToMainContent');
				if (interstitialOfferBanner) {
					$(interstitialOfferBanner).after(data);
				} else if (skipToMain.length) {
					skipToMain.after(data);
				} else {
					$('body').prepend(data);
				}
				const $alert = $(alertClass);
				const sessionName = $alert.data('session');
				const alertPresent = !!($alert.length > 0);
				const alertDismissed = Boolean(window.sessionStorage.getItem(sessionName));

				if (alertPresent && !alertDismissed) {
					const shownClassName = `Banner--shown`;

					$alert.addClass(shownClassName);
					setAlertHeightProperty();
					const closeBanner = document.querySelector(selectors.closeBanner);
					$(closeBanner).on('click', function () {
						const sessionName = $alert.data('session');
						window.FS.GDPR.ifAllowed('functional', function () {
							window.sessionStorage.setItem(sessionName, 'true');
						});
						$alert.slideUp({
							duration: 800,
							complete: () => {
								$alert.removeClass('Banner--shown');
								setAlertHeightProperty();
							},
							step: setAlertHeightProperty,
						});
					});
					// Trigger "alertBannerAdded" event
					$(document).trigger('alertBannerAdded');
				} else {
					setAlertHeightProperty();
					$(document).trigger('noAlertBanner');
				}
			} else {
				setAlertHeightProperty();
				$(document).trigger('noAlertBanner');
			}
		});
	} else {
		setAlertHeightProperty();
		$(document).trigger('noAlertBanner');
	}
}
